
import { createSlice } from "@reduxjs/toolkit";

let initialCurrentNewsJourney = {}
const currentNewsJourneySlice = createSlice({
    name: 'currentNewsJourney',
    initialState: initialCurrentNewsJourney,
    reducers: {
        setCurrentNewsJourney: (state, action) => {
            return {
                ...action.payload
            }
        },
        resetCurrentNewsJourney: () => {
            return initialCurrentNewsJourney
        }
    },
});

export const { setCurrentNewsJourney, resetCurrentNewsJourney } = currentNewsJourneySlice.actions;
export default currentNewsJourneySlice.reducer;